<template>
	<div class="pa-2">
		<!-- title -->
		<v-subheader class="subheading px-2">
			<slot name="title">{{ title }}</slot>
			<v-spacer/>
			<!-- addtional items button -->
			<a 	v-if="maxVisibleItems && items.length > maxVisibleItems"
				class="caption text--primary"
				href=""
				@click="toggleMoreItems">
			
				{{ $t(moreItemsVisible ? 'GENERAL_COLLAPSE_TEXT' : 'GENERAL_EXPAND_TEXT') }}
			</a>
		</v-subheader>

		<slot name="header" />

		<!-- no-data text -->
		<v-layout class="pl-2 font-italic text--secondary" v-if="!items.length">
			{{ noDataText }}
		</v-layout>

		<div class="item-list pl-1" :style="`border-left-color: ${color}`">
			<v-list dense>
				<template v-for="(item, i) in visibleItems">
					<v-divider v-if="!!i" :key="'d' + item[itemKey]" />
					<div :key="item[itemKey]"><slot :item="item" /></div>
				</template>
			</v-list>
		</div>
		
		<slot name="footer" />
	</div>
</template>

<script>
export default {
	name: 'expand-list',
	props: {
		items: Array,
		itemKey: { type: String, default: 'id' },
		maxVisibleItems: { type: Number, default: 3 },
		maxInlineItems: { type: Number, default: 50 },
		color: { type: String, default: 'grey' },
		title: String,
		noDataText: String,
	},
	data() { return {
		moreItemsVisible: false,
	}},
	computed: {
		visibleItems() {
			return this.moreItemsVisible ? this.items : this.items.slice(-this.maxVisibleItems);
		},
	},
	methods: {
		toggleMoreItems(e) {
			e.preventDefault();
			if (this.items.length > this.maxInlineItems) {
				this.$emit('showAll');
			}
			else {
				this.moreItemsVisible = !this.moreItemsVisible;
				this.$emit(this.moreItemsVisible ? 'expand' : 'collapse');
			}
			return false;
		},
	},
}
</script>

<style scoped lang="less">
	.item-list {
		border-left-width: 3px;
		border-left-style: solid;

		.v-list--dense { padding: 0 }
	}
</style>